import { AddressState, initialAddressState } from "@app/address/store/address.state";
import { AuditLogStoreState, initialAuditLogState } from "@app/audit-log/store/reducers/audit-log.reducers";
import { AuthState, initialAuthState } from "@app/auth/store/auth.state";
import { ServicePlanState, initialAlulaPanelState, initialProjectState, initialServicePlanState } from "@app/project/store/projects.state";
import { initialEmergencyContactState, initialMunicipalityState } from "@app/project/store/reducers";
import { EventLogState, initialEventLogState } from "@app/project/store/reducers/event-log.reducers";
import { LocalizerState, initialLocalizerState } from "./localizer.state";
import { RouterState, initialRouteState } from "./router.state";

import { EntityStoreState } from "@app/entity/store";
import { initialEntityState } from "@app/entity/store/entity.state";
import { ProjectStoreState } from "@app/project/store";
import { CHZoneState } from "@app/project/store/clarehome.state";
import { UserManagementStoreState } from "@app/user/store";
import { initialUserManagementState } from "@app/user/store/user-management.state";

export interface State {
    address: AddressState;
    auth: AuthState;
    "user-management": UserManagementStoreState.UserManagementState;
    entity: EntityStoreState.EntityState;
    routerReducer: RouterState;
    project: ProjectStoreState.ProjectState;
    chzone: CHZoneState;
    municipality: ProjectStoreState.MunicipalityState;
    "emergency-contact": ProjectStoreState.EmergencyContactState;
    localizer: LocalizerState;
    "event-log-reducer": EventLogState;
    servicePlan: ServicePlanState;
    alula: ProjectStoreState.AlulaPanelState;
    "audit-log": AuditLogStoreState;
}

export const initialState: State = {
    address: initialAddressState,
    auth: initialAuthState,
    "user-management": initialUserManagementState,
    entity: initialEntityState,
    routerReducer: initialRouteState,
    project: initialProjectState,
    chzone: null,
    municipality: initialMunicipalityState,
    "emergency-contact": initialEmergencyContactState,
    localizer: initialLocalizerState,
    servicePlan: initialServicePlanState,
    "event-log-reducer": initialEventLogState,
    alula: initialAlulaPanelState,
    "audit-log": initialAuditLogState,
};
